// extracted by mini-css-extract-plugin
export default {"btn":"Vww5vQrzvJLs5Pp5gK2X"};